import React, { useEffect, useState } from 'react';
import { useTitle } from '../../Hooks';
import { Table, Header, Pagination } from 'react-frontier';
import { useParams, Link } from 'react-router-dom';
import { Business } from '../../Classes';
import { addCommas } from '@tempu/components/Util';
import { firstBy } from 'thenby';
import moment from 'moment';
import classNames from 'classnames';
import API, { PAGE } from '../../API';

const PAGE_SIZE = 5;

var BusinessInfo = ()=>{
	var params = useParams<{ business_id: string }>();
	var business_id = parseInt(params?.business_id);
	var [loadError, setLoadError] = useState<string>(null);
	var [business, setBusiness] = useState<Business>(null);
   var { setTitle } = useTitle();
   var [payoutsLoading, setPayoutsLoading] = useState<boolean>(false);
   var [postingsLoading, setPostingsLoading] = useState<boolean>(false);
   var [payoutsPage, setPayoutsPage] = useState<number>(0);
   var [postingsPage, setPostingsPage] = useState<number>(0);


	useEffect(()=>{
		setTitle('Información de negocio');
		API.getAdminBusiness(business_id).then(business=>{
			if(business.error) return setLoadError(business.message);
			return setBusiness(business.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener la informacion del negocio. (GBI-1)'); 
		})
      getPayouts();
      getPostings();
	}, []);

   var onPayoutsPageChange = (page: number)=>{
		setPayoutsPage(page);
		getPayouts(page);
	}

   var onPostingsPageChange = (page: number)=>{
		setPostingsPage(page);
		getPostings(page);
	}

   var getPayouts = (get_page?: number)=>{
      var offset = (get_page > 0) ? Math.max(0, (get_page || payoutsPage) * PAGE_SIZE) : 0;

      setPayoutsLoading(true);
      API.getBusinessPayouts(business_id, offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
         return setBusiness((prev) => ({
            ...prev,
            payouts: res.data
         }));
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener las liquidaciónes del negocio. (GBP-1)'); 
		}).finally(()=>{
         setPayoutsLoading(false);
      })
   }

   var getPostings = (get_page?: number)=>{
      var offset = (get_page > 0) ? Math.max(0, (get_page || postingsPage) * PAGE_SIZE) : 0;

      setPostingsLoading(true);
      API.getBusinessPostings(business_id, false, offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
         return setBusiness((prev) => ({
            ...prev,
            postings: res.data
         }));
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener los empleos del negocio. (GBP-1)'); 
		}).finally(()=>{
         setPostingsLoading(false);
      })
   }

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if (!business || !business.payouts || !business.postings) {
		return <Header loading text='Cargando datos' />;
	}

	return <div>
		<Table
			title='Información'
			style={{ maxWidth: 600, margin: 'auto' }}
			striped
			details
			data={[
				['ID', business.business_id],
				['Nombre', business.business_name],
            ['Estatus', <div className={classNames("fr label", {
               green: business.active && !business.deleted,
               yellow: !business.active && !business.deleted,
               red: business.deleted
            })}>
               {business.deleted ? 'Eliminado' : business.active ? 'Activo' : 'Inactivo'}
            </div>],
            ['Creación', moment.unix(business.date_created).format('DD/MMM/YY HH:mm')],
            ['Creador', business.user_creator_name.toUpperCase()],
            ['Webiste', business.website || 'No Info'],
            ['About', business.about || 'No Info']
			]}
		/>
      <Table
			title='Empleos'
			headers={['ID', 'Nombre', 'Creado', 'Estatus']}
			selectable
			collapsingIndexes={[0 , 2, 3, 4]}
         style={{ maxWidth: 600 , margin: 'auto', marginTop: 15 }}
         footer={business.postings.length >= PAGE_SIZE || postingsPage !== 0 ? (
            <Table.Row>
               <Table.Cell colSpan={7}>
                  <div style={{ textAlign: 'right' }}>
                     <Pagination page={postingsPage} onPageChange={onPostingsPageChange} />
                  </div>
               </Table.Cell>
            </Table.Row>
         ) : null}
		>
		{postingsLoading ? <Table.Row><Table.Cell colSpan={6}><Header centered loading text={'Cargando Datos.'}/></Table.Cell></Table.Row> : business.postings.length === 0 ? <Table.Row><Table.Cell colSpan={7} centered style={{ fontSize: 14, fontWeight: 'bold'}}>No se encontraron registros.</Table.Cell></Table.Row> :
			business.postings.sort(firstBy(p=>p.date_created)).map(p=> <Table.Row compact as={Link} key={p.posting_id} to={`/business/${business_id}/posting/${p.posting_id}`}>
				<Table.Cell>{p.posting_id}</Table.Cell>
				<Table.Cell>{p.posting_name}</Table.Cell>
				<Table.Cell>{moment.unix(p.date_created).format('DD/MMM/YY HH:mm')}</Table.Cell>
            <Table.Cell>
					<div className={classNames("fr label", {
						green: p.approved && p.approved,
						yellow: p.approved && !p.published,
						red: !p.approved
					})}>
						{!p.approved ? 'No aprobado' : p.published ? 'Publicado' : 'No Publicado'}
					</div>
				</Table.Cell>
			</Table.Row>)}
		</Table>
      <Table
			title='Liquidaciones'
			headers={['ID', 'Empleo', 'Cantidad', 'Fecha', 'Estatus']}
			selectable
			collapsingIndexes={[0 , 2, 3, 4]}
         style={{ maxWidth: 600 , margin: 'auto', marginTop: 15 }}
         footer={business.payouts.length >= PAGE_SIZE || payoutsPage !== 0 ? (
            <Table.Row>
               <Table.Cell colSpan={7}>
                  <div style={{ textAlign: 'right' }}>
                     <Pagination page={payoutsPage} onPageChange={onPayoutsPageChange} />
                  </div>
               </Table.Cell>
            </Table.Row>
         ) : null}
		>
		{payoutsLoading ? <Table.Row><Table.Cell colSpan={6}><Header centered loading text={'Cargando Datos.'}/></Table.Cell></Table.Row> : business.payouts.length === 0 ? <Table.Row><Table.Cell colSpan={7} centered style={{ fontSize: 14, fontWeight: 'bold'}}>No se encontraron registros.</Table.Cell></Table.Row> :
			business.payouts.sort(firstBy(p=>p.paid)).map(p=> <Table.Row collapsingIndexes={[0 , 2, 3, 4]} compact as={Link} key={p.payout_id} to={`/admin/payouts/${p.payout_id}`}>
				<Table.Cell>{p.payout_id}</Table.Cell>
				<Table.Cell>{p.posting_name}</Table.Cell>
				<Table.Cell>{'$' + addCommas(p.total_pending)}</Table.Cell>
				<Table.Cell>{moment.unix(p.date_paid).format('DD/MMM/YY HH:mm')}</Table.Cell>
				<Table.Cell>
					<div className={classNames("fr label", {
						green: p.paid && !p.cancelled,
						yellow: !p.paid && !p.cancelled,
						red: p.cancelled
					})}>
						{p.cancelled ? 'Cancelada' : p.paid ? 'Pagada' : 'No Pagada'}
					</div>
				</Table.Cell>
			</Table.Row>)}
		</Table>
	</div>
}

export default BusinessInfo;